"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect, useState, type ReactNode } from "react";

import { NativeAppGuard } from "@/components/native/native-app-guard";
import { NativeRuntime } from "@/components/native/native-runtime";
import { getSupabaseBrowserClient } from "@/lib/supabase/client";
import { MissingSupabaseConfigError } from "@/lib/supabase/env";

export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  useEffect(() => {
    let supabase;

    try {
      supabase = getSupabaseBrowserClient();
    } catch (error) {
      if (!(error instanceof MissingSupabaseConfigError)) {
        console.error("A Supabase Auth figyelő nem indítható el.", error);
      }
      return;
    }

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event) => {
      if (event === "SIGNED_OUT") {
        queryClient.clear();
      }
    });

    return () => subscription.unsubscribe();
  }, [queryClient]);

  return (
    <QueryClientProvider client={queryClient}>
      <NativeRuntime>
        <NativeAppGuard>{children}</NativeAppGuard>
      </NativeRuntime>
    </QueryClientProvider>
  );
}
